export default function createApp(App, rootElement) {
  var isLoaded = document.readyState === 'complete';
  var app;

  if (!isLoaded) {
    document.addEventListener('readystatechange', () => {
      if (document.readyState === 'complete') {
        app = new App(rootElement).$mount();
        isLoaded = true;
      }
    });
  } else {
    app = new App(rootElement).$mount();
  }

  var promise = new Promise(resolve => {
    document.addEventListener('readystatechange', () => {
      if (document.readyState === 'complete') {
        setTimeout(() => resolve(app), 0);
      }
    });
  });
  return function useApp() {
    if (isLoaded) {
      return Promise.resolve(app);
    }

    return promise;
  };
}